export default [
  {
    "key": "menu-0",
    "kind": "MENU",
    "parent": null,
    "title": "교육원소개",
    "to": "/intro",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-0",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "테크에듀",
    "to": "/intro",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-1",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "경영원칙과비전",
    "to": "/intro/vision",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-2",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "사업영역",
    "to": "/intro/business",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-3",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "교육체계",
    "to": "/intro/system",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-4",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "교육운영",
    "to": "/intro/operation",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-5",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "교육플랫폼",
    "to": "/intro/platform",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-6",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "조직도",
    "to": "/intro/organization",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-0-7",
    "kind": "CHILD",
    "parent": "menu-0",
    "title": "찾아오시는길",
    "to": "/intro/location",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1",
    "kind": "MENU",
    "parent": null,
    "title": "교육안내",
    "to": "/guide",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-0",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "사업주환급(기업)",
    "to": "/guide/refund-company",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-1",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "내일배움카드(개인)",
    "to": "/guide/card-individual",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-2",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "법정의무교육",
    "to": "/guide/legal",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-3",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "디지털융합",
    "to": "/guide/digital",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-4",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "산업안전보건교육",
    "to": "/guide/safety",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-5",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "기업직업훈련카드",
    "to": "/guide/company-card",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-6",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "과정개발",
    "to": "/guide/course-development",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-7",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "학습운영관리",
    "to": "/guide/operation",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-8",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "환불규정및절차",
    "to": "/guide/refund-policy",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-9",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "훈련생 유의사항",
    "to": "/guide/notice",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-10",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "모사답안처리기준",
    "to": "/guide/plagiarism",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-11",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "부정훈련방지안내",
    "to": "/guide/fraud-prevention",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-1-12",
    "kind": "CHILD",
    "parent": "menu-1",
    "title": "교육이용안내",
    "to": "/guide/usage",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-2",
    "kind": "MENU",
    "parent": null,
    "title": "법정필수교육",
    "to": "/course/legal",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-2-0",
    "kind": "CHILD",
    "parent": "menu-2",
    "title": "공통법정의무교육",
    "to": "/course/legal/common",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-2-1",
    "kind": "CHILD",
    "parent": "menu-2",
    "title": "직무법정의무교육",
    "to": "/course/legal/job",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-3",
    "kind": "MENU",
    "parent": null,
    "title": "산업안전교육",
    "to": "/course/safety",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-3-0",
    "kind": "CHILD",
    "parent": "menu-3",
    "title": "근로자",
    "to": "/course/safety/worker",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-3-1",
    "kind": "CHILD",
    "parent": "menu-3",
    "title": "관리감독자",
    "to": "/course/safety/supervisor",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-4",
    "kind": "MENU",
    "parent": null,
    "title": "직무향상교육",
    "to": "/course/job",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-4-0",
    "kind": "CHILD",
    "parent": "menu-4",
    "title": "매뉴픽처링",
    "to": "/course/job/manufacturing",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-4-1",
    "kind": "CHILD",
    "parent": "menu-4",
    "title": "IT",
    "to": "/course/job/it",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-4-2",
    "kind": "CHILD",
    "parent": "menu-4",
    "title": "직무역량",
    "to": "/course/job/competency",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-4-3",
    "kind": "CHILD",
    "parent": "menu-4",
    "title": "자격증",
    "to": "/course/job/certificate",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-4-4",
    "kind": "CHILD",
    "parent": "menu-4",
    "title": "외국어",
    "to": "/course/job/language",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5",
    "kind": "MENU",
    "parent": null,
    "title": "오프라인교육",
    "to": "/course/offline",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-0",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "ChatGPT",
    "to": "/course/offline/chatgpt",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-1",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "디지털전환",
    "to": "/course/offline/dx",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-2",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "빅데이터",
    "to": "/course/offline/bigdata",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-3",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "디지털트윈",
    "to": "/course/offline/digital-twin",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-4",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "ESG",
    "to": "/course/offline/esg",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-5",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "JMP",
    "to": "/course/offline/jmp",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-6",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "제조AI",
    "to": "/course/offline/manufacturing-ai",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-7",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "지능형로봇",
    "to": "/course/offline/robot",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-8",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "안전보건관리",
    "to": "/course/offline/safety",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-5-9",
    "kind": "CHILD",
    "parent": "menu-5",
    "title": "금형기술",
    "to": "/course/offline/mold",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6",
    "kind": "MENU",
    "parent": null,
    "title": "학습지원센터",
    "to": "/support",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-0",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "공지사항",
    "to": "/support/notice",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-1",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "Q&A",
    "to": "/support/qna",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-6-2",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "FAQ",
    "to": "/support/faq",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-3",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "뉴스레터",
    "to": "/support/newsletter",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-4",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "학습자료실",
    "to": "/support/library",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-9",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "용어사전",
    "to": "/support/glossary",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-5",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "뷰어다운로드",
    "to": "/support/viewer",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-6",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "1:1문의",
    "to": "/support/inquiry",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-6-7",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "PC원격지원",
    "to": "/support/remote",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-6-8",
    "kind": "CHILD",
    "parent": "menu-6",
    "title": "수강후기",
    "to": "/support/review",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-7",
    "kind": "MENU",
    "parent": null,
    "title": "나의강의실",
    "to": "/my",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-0",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "진행중인 과정",
    "to": "/my",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-1",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "재응시 과정",
    "to": "/my/retake",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-2",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "학습종료 과정",
    "to": "/my/ended",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-3",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "수강신청 내역",
    "to": "/my/enrollment",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-4",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "상담신청 내역",
    "to": "/my/consult",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-5",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "토론게시판",
    "to": "/my/discussion",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-6",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "나만의 학습노트",
    "to": "/my/note",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-7",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "개인/추가 결제",
    "to": "/my/payment",
    "protected": true,
    "unavailable": true
  },
  {
    "key": "menu-7-11",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "개인정보변경",
    "to": "/my/profile",
    "protected": true,
    "unavailable": false
  },
  {
    "key": "menu-7-8",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "인증방법",
    "to": "/my/certify",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-7-9",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "아이핀 인증방법",
    "to": "/my/certify/ipin",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "menu-7-10",
    "kind": "CHILD",
    "parent": "menu-7",
    "title": "아이핀 발급방법",
    "to": "/my/certify/ipin-issue",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "quick-consult",
    "kind": "QUICK",
    "parent": null,
    "title": "1:1 학습상담",
    "to": "/support/inquiry",
    "action": null,
    "icon": "chat",
    "short": "상담",
    "protected": true,
    "unavailable": false,
    "targets": [
      "/support/inquiry",
      "/support/qna",
      "/my/consult"
    ]
  },
  {
    "key": "quick-remote",
    "kind": "QUICK",
    "parent": null,
    "title": "원격지원",
    "to": "/support/remote",
    "action": null,
    "icon": "monitor",
    "short": "원격",
    "protected": false,
    "unavailable": false,
    "targets": [
      "/support/remote"
    ]
  },
  {
    "key": "quick-library",
    "kind": "QUICK",
    "parent": null,
    "title": "자료실",
    "to": "/support/library",
    "action": null,
    "icon": "folder",
    "short": "자료",
    "protected": false,
    "unavailable": false,
    "targets": [
      "/support/library",
      "/support"
    ]
  },
  {
    "key": "quick-b2b",
    "kind": "QUICK",
    "parent": null,
    "title": "기업교육 신청양식",
    "to": null,
    "action": null,
    "href": "/files/company_edu.zip",
    "icon": "download",
    "short": "신청양식",
    "protected": false,
    "unavailable": false
  },
  {
    "key": "footer-1",
    "kind": "FOOTER",
    "parent": null,
    "title": "이용약관",
    "to": "/policy/terms",
    "strong": false,
    "protected": false,
    "unavailable": false
  },
  {
    "key": "footer-0",
    "kind": "FOOTER",
    "parent": null,
    "title": "개인정보처리방침",
    "to": "/policy/privacy",
    "strong": false,
    "protected": false,
    "unavailable": false
  },
  {
    "key": "footer-4",
    "kind": "FOOTER",
    "parent": null,
    "title": "환불규정",
    "to": "/policy/refund",
    "strong": false,
    "protected": false,
    "unavailable": false
  },
  {
    "key": "footer-2",
    "kind": "FOOTER",
    "parent": null,
    "title": "학습지원센터",
    "to": "/support",
    "strong": false,
    "protected": false,
    "unavailable": false
  }
]
